import { createReducer } from 'helpers/redux';
import {
  SET_INITIALISED,
  SET_DATA,
  SET_BASEPATH,
  SET_BASE_BREADCRUMB,
  ADD_TO_HISTORY,
  SET_LOADING,
  SET_ERROR,
} from './types';

export const initialState = {
  initialised: false,
  data: {
    goals: {
      'load a Bike - garage': '5b8577cf-f559-41a5-a5ea-dc595766a7d2',
      'configuration started': '079024c1-2b5e-46ab-b6b7-d9aebe7d1b17',
      'save configuration to garage': 'a0d91e40-e66b-4b41-af2b-83e5a4425993',
      'send configuration to dealer': '0566bc80-2bae-44e4-8bf8-184219b021ee',
      'cta - print - summary page': '7c9ee324-9e7a-4a13-94fb-7b6801696a2d',
      'cta - Test ride - summary page': '926d98ad-a77e-4bd7-a88a-aee0a1c29be8',
      'view Configurator landing page': '37346670-ea04-445e-b5b7-7b93f73472f7',
    },
    groups: [],
    filters: [],
    labels: {},
    hero: {
      heroImage: {},
    },
    ctas: {},
    disclaimers: {},
    currency: null,
    sendToDealer: {},
    icons: {
      calculator: ''
    }
  },
  basepath: '/',
  baseBreadcrumb: [],
  history: [],
  loading: true,
};

const appReducer = createReducer({
  initialState,
  reducers: {
    [SET_INITIALISED]: state => ({
      ...state,
      initialised: true,
      loading: false,
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      loading: action.payload,
    }),
    [SET_DATA]: (state, action) => ({
      ...state,
      data: {
        ...action.payload,
      },
    }),
    [SET_BASEPATH]: (state, action) => ({
      ...state,
      basepath: action.payload,
    }),
    [SET_BASE_BREADCRUMB]: (state, action) => ({
      ...state,
      breadcrumb: action.payload,
    }),
    [ADD_TO_HISTORY]: (state, action) => ({
      ...state,
      history: state.history.concat(action.payload),
    }),
    [SET_ERROR]: (state, action) => ({
      ...state,
      error: action.payload,
    }),
  },
});

export default appReducer;
